import {
    Action, Middleware
} from 'redux';

import { productSelectorEffects } from '../../../product-selector/product-selector.effects';
import {
    sessionLifecycleEffects, idleSessionEffects
} from '../../../session';
import { userProfilesEffects } from '../../../user-profiles/user-profiles.effects';
import {
    AppContext, AppState
} from '../../app.types';
import { EffectOptions } from './app-effects-middleware.types';
import {
    fetchFailureEffects, logoutEffects
} from './effects';

/**
 * Main redux action side effects for the app responding to redux actions.
 * This can be used to react to state wide actions for global handling.
 *
 * To keep Portal Shell small and while it is simple,
 * why not use this api directly without any third party dependencies?
 *
 * This is where you would typically write side effects in something
 * like https://redux-saga.js.org/docs/api.
 */
export function appEffectsMiddleware (context: AppContext): Middleware<Record<string, null>, AppState> {
    return ({
        dispatch,
        getState
    }) => (next) => (action: Action | any) => {
        const options: EffectOptions = {
            context,
            action,
            dispatch,
            getState
        };

        fetchFailureEffects(options);
        logoutEffects(options);
        sessionLifecycleEffects(options);
        idleSessionEffects(options);
        productSelectorEffects(options);
        userProfilesEffects(options);

        return next(action);
    };
}
